import { GoBackToMobileAppProps } from './mobileApp.types';

export const goBackToMobileApp = (goToMobileApp: GoBackToMobileAppProps) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(goToMobileApp));
  }
  return;
};
